"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var root_entity_organization_users_provider_service_1 = require("../api/root-entity-organization-users-provider.service");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var um_extensions_service_1 = require("../api/um-extensions-service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var core_1 = require("@angular/core");
var HttpRootEntityOrganizationUsersProviderService = /** @class */ (function (_super) {
    __extends(HttpRootEntityOrganizationUsersProviderService, _super);
    function HttpRootEntityOrganizationUsersProviderService(umExtensionsService, kbService, deService, classifierService) {
        var _this = _super.call(this) || this;
        _this.umExtensionsService = umExtensionsService;
        _this.kbService = kbService;
        _this.deService = deService;
        _this.classifierService = classifierService;
        return _this;
    }
    HttpRootEntityOrganizationUsersProviderService.prototype.getUsers = function (rootCategoryId, rootEntityId, entity) {
        var _this = this;
        return this.getUsersIds(rootCategoryId, rootEntityId, entity)
            .pipe(operators_1.take(1), operators_1.switchMap(function (usersIds) {
            return _this.classifierService.loadClassifiersByIds('User', usersIds, false)
                .pipe(operators_1.take(1), operators_1.map(function (users) { return users.getData(); }));
        }));
    };
    HttpRootEntityOrganizationUsersProviderService.prototype.getUsersIds = function (rootCategoryId, rootEntityId, entity) {
        var _this = this;
        return this.getOrganizationFields(rootCategoryId)
            .pipe(operators_1.switchMap(function (organizationMetaFields) {
            if (organizationMetaFields.length === 0) {
                return of_1.of(new Set());
            }
            var fieldsSystemNames = organizationMetaFields.map(function (metaField) { return metaField.getMetaFieldId().getSystemName(); });
            return _this.getEntityOrganizationsIds(rootCategoryId, rootEntityId, fieldsSystemNames, entity);
        }), operators_1.switchMap(function (organizationsIds) {
            if (organizationsIds.size === 0) {
                return of_1.of([]);
            }
            return _this.umExtensionsService.getUsersByOrganizations(Array.from(organizationsIds))
                .pipe(operators_1.take(1), operators_1.map(function (usersByOrganization) {
                var uniqueUsersIds = new Set();
                usersByOrganization.forEach(function (usersIds) { return usersIds.forEach(function (userId) { return uniqueUsersIds.add(userId); }); });
                return Array.from(uniqueUsersIds);
            }));
        }));
    };
    HttpRootEntityOrganizationUsersProviderService.prototype.getOrganizationFields = function (rootCategoryId) {
        return this.kbService
            .getMetaFields(rootCategoryId)
            .pipe(operators_1.map(function (metaFields) { return metaFields.filter(function (metaField) { return metaField.getCompoundCategorySystemName() === 'Organization'; }); }), operators_1.take(1));
    };
    HttpRootEntityOrganizationUsersProviderService.prototype.getEntityOrganizationsIds = function (categoryName, instanceId, organizationFields, rootEntity) {
        return (rootEntity ? of_1.of(rootEntity) : this.deService.loadEntityByInstanceId(categoryName, instanceId, false, organizationFields))
            .pipe(operators_1.map(function (entity) {
            var organizationsIds = new Set();
            for (var _i = 0, organizationFields_1 = organizationFields; _i < organizationFields_1.length; _i++) {
                var fieldsSystemName = organizationFields_1[_i];
                var organization = entity.getProperty(fieldsSystemName).value;
                if (organization != null) {
                    organizationsIds.add(organization.getId());
                }
            }
            return organizationsIds;
        }));
    };
    HttpRootEntityOrganizationUsersProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [um_extensions_service_1.UmExtensionsService,
            idm_kb_service_client_js_1.KbService,
            idm_de_service_client_js_1.DeService,
            idm_classifier_service_client_js_1.ClassifierService])
    ], HttpRootEntityOrganizationUsersProviderService);
    return HttpRootEntityOrganizationUsersProviderService;
}(root_entity_organization_users_provider_service_1.RootEntityOrganizationUsersProviderService));
exports.HttpRootEntityOrganizationUsersProviderService = HttpRootEntityOrganizationUsersProviderService;
//# sourceMappingURL=http-root-entity-organization-users-provider.service.js.map